import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  private readonly INVALID_NAMES = new Set([
    'ambulance',
    'user',
    'ambulance user',
    'ussd',
    'ivr',
    'ussd ussd',
    'ivr ivr',
  ]);

  private statusSource = new BehaviorSubject<string>('');
  currentStatus$ = this.statusSource.asObservable();

  private patientSource = new BehaviorSubject<any>(null);
  patientDetails$ = this.patientSource.asObservable();

  private notConnected = new BehaviorSubject<any>(null);
  notConnectedOberver$ = this.notConnected.asObservable();

  private prescriptionAdded = new BehaviorSubject<any>(null);
  prescriptionAddedOberver$ = this.prescriptionAdded.asObservable();

  constructor(private router: Router) {}

  private normalize(value?: string): string {
    return value?.trim().toLowerCase() || '';
  }

  setStatus(status: string) {
    this.statusSource.next(status);
  }

  setNotConnected(data: any) {
    this.notConnected.next(data);
  }
  setPatientDetails(data: any) {
    this.patientSource.next(data);
  }

  setPrescriptionAlert(data: any) {
    this.prescriptionAdded.next(data);
  }

  getDisplayName(user: any): string {
    if (!user) return 'Not Available';

    const firstName = this.normalize(user.first_name);
    const lastName = this.normalize(user.last_name);

    if (!firstName || !lastName) {
      return 'Not Available';
    }

    const fullName = `${firstName} ${lastName}`;

    if (this.INVALID_NAMES.has(firstName) || this.INVALID_NAMES.has(fullName)) {
      return 'Not Available';
    }

    return `${this.capitalize(user.first_name)} ${this.capitalize(
      user.last_name,
    )}`;
  }

  private capitalize(value: string): string {
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  public currentRoute: any;
  public previousRoute: any;
  public activeTab: any;
}
